import { ElementType } from 'domelementtype'
import { Element as DomElement } from 'domhandler'
import { AnimatePresence, motion } from 'framer-motion'
import { domToReact } from 'html-react-parser'
import React, { useMemo } from 'react'

import Flex from '@/modules/components/Flex'
import Icon from '@/modules/components/Icon'
import Typography from '@/modules/components/Typography'

export const ToggleContentContainer = ({
  domNode,
  options,
}: {
  domNode: DomElement
  options: any
}) => {
  const [isContentShow, setIsContentShow] = React.useState(true)
  const toggleContentShow = () => {
    setIsContentShow(!isContentShow)
  }
  const container = domNode
  const contentWrapper = useMemo(() => {
    if ('children' in container && container.children.length > 0) {
      return container.children.filter(
        (childNode: any) =>
          childNode.name === 'div' &&
          childNode.attribs.class ===
            'wp-block-ub-content-toggle-accordion-content-wrap'
      )
    } else {
      return [
        new DomElement(
          'div',
          { class: 'wp-block-ub-content-toggle-accordion-content-wrap' },
          undefined,
          ElementType.Tag
        ),
      ]
    }
  }, [container])

  const title = useMemo(() => {
    let tempTitle = ''
    if ('children' in container && container.children.length > 0) {
      container.children.forEach((childNode: any) => {
        if (
          childNode?.attribs?.class ===
          'wp-block-ub-content-toggle-accordion-title-wrap'
        ) {
          tempTitle = childNode?.children[1]?.children[0].data
        }
      })
    }
    return tempTitle
  }, [container])

  //const toggleContentWrap = domNode[0].children.filter()
  return (
    <>
      <Flex
        className="wp-block-ub-content-toggle-accordion-title-wrap"
        alignItems={'center'}
        justifyContent={'space-between'}
        onClick={toggleContentShow}
        customCss={{ cursor: 'pointer' }}
      >
        <Typography
          variant="p"
          as="h2"
          color={'#0B1426'}
          fontWeight={600}
          fontSize={[22, 24, 28]}
          lineHeight={'135%'}
        >
          {title}
        </Typography>
        {isContentShow ? (
          <Icon.ChevronUp18x11 fontSize={[18, 22]} color="#001B3C" />
        ) : (
          <Icon.ChevronDown18x11 fontSize={[18, 22]} color="#001B3C" />
        )}
      </Flex>
      <AnimatePresence>
        {isContentShow && (
          <motion.div
            initial={{
              height: 0,
              opacity: 0,
            }}
            animate={{
              height: 'auto',
              opacity: 1,
            }}
            exit={{
              height: 0,
              opacity: 0,
            }}
            transition={{ bounce: 0, duration: 0.2 }}
          >
            {domToReact(contentWrapper, options)}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}
